module.exports = __webpack_public_path__ + "img/3-2.5d5f97c1.svg";